import React, { Component } from 'react';
import styled from 'styled-components';

import mediaWidth from '../../utils/mediaWidth/mediaWidth';
import api from '../../services/api';
import directions from '../../utils/directionsData';
import color from '../../utils/colors';
import Analytics from '../../services/Analytics';

import AnimationContainer from '../../common/FadeAnimation';
import StartScreenDirection from '../../common/StartScreenDirection';
import DropDownList from '../../common/DropDownList';
import Decisions from '../../common/Decisions';
import ContactsFormBlock from '../../common/ContactsFormBlock';
import Footer from '../../components/Footer';

import tools from './tools';
import anchorScroll from '../../utils/anchorScroll';

function scrollToBlocks() {
    if (['#services', '#decisions'].includes(window.location.hash)) {
        if (document.querySelector(window.location.hash)) {
            anchorScroll({ current: document.querySelector(window.location.hash) });
        } else {
            setTimeout(scrollToBlocks, 1000);
        }
    }
}

class Direction extends Component {
    constructor(props) {
        super(props);
        const { match: { params: { direction } } } = this.props;

        this.sliderRef = React.createRef();
        this.sliderWrapperRef = React.createRef();

        this.state = tools.getDirectionState(directions, direction);

        this.getCases = this.getCases.bind(this);
        this.handleGetMoreCases = this.handleGetMoreCases.bind(this);
        this.handleSwitchFilter = this.handleSwitchFilter.bind(this);
        this.scrollToDecitions = this.scrollToDecitions.bind(this);
        this.delay = null;
    }

    componentDidMount() {
        const { match: { params: { direction } } } = this.props;
        this.getCases();
        Analytics.pageView('/direction', direction);
        scrollToBlocks();
    }

    componentDidUpdate(prevProps) {
        const { match: { params: { direction: prevDirection } } } = prevProps;
        const { match: { params: { direction } } } = this.props;
        if (direction !== prevDirection) {
            this.setDirectionState(direction);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.delay);
    }

    setDirectionState(direction) {
        this.setState(tools.getDirectionState(directions, direction), () => this.getCases());
    }

    getCases() {
        const { filters, isChangeFilter, casesState: { cases, limit } } = this.state;
        const skip = isChangeFilter ? 0 : cases.length;
        const filterName = tools.getFilterName(filters);
        const filtersID = tools.getFiltersIDArray(filters, filterName);

        api.getCases(limit, skip, filtersID)
            .then(({ data }) => this.update(data));
    }

    update(incomingData) {
        const { isChangeFilter, casesState: prevCasesState } = this.state;
        const casesState = tools.updateCasesState(prevCasesState, incomingData, isChangeFilter);

        this.setState({ isChangeFilter: false, isLoadMoreCases: false, casesState });
    }

    handleGetMoreCases() {
        const { casesState } = this.state;
        const moreDownloadNum = tools.getMoreDownloadNum(casesState);
        if (moreDownloadNum > 0) {
            this.setState({ isLoadMoreCases: true });
        }
    }

    handleSwitchFilter(filterName) {
        const { filters: prevFilters } = this.state;
        const filters = tools.updateFilters(prevFilters, filterName);

        this.setState({ filters, isChangeFilter: true });

        this.setState({ filters, isChangeFilter: true }, () => {
            this.scrollToDecitions();
        });
    }

    scrollToDecitions() {
        const { filters } = this.state;
        let activeChilde;
        filters.map((filter, index) => {
            if (filter.isActive) {
                activeChilde = index;
            }
            return activeChilde;
        });

        const childeOffsetLeft = this.sliderRef.current.children[activeChilde].offsetLeft;
        this.sliderWrapperRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' });

        this.delay = setTimeout(() => {
            this.sliderRef.current.scrollTo(childeOffsetLeft, 0);
        }, 700);

        // eslint-disable-next-line indent
        // const el = this.sliderRef.current;
        // this.sliderRef.current.onscroll = (() => {
        //     // eslint-disable-next-line max-len
        // eslint-disable-next-line max-len
        //     if (el.scrollLeft === childeOffsetLeft || (el.scrollLeft + el.clientWidth) >= el.scrollWidth) {
        // eslint-disable-next-line max-len
        //         this.sliderWrapperRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
        //     }
        // });
    }

    render() {
        const {
            isChangeFilter, isLoadMoreCases, services, filters, casesState,
        } = this.state;
        const {
            className,
            match: { params: { direction } },
            handleOpenPopUp,
            handleChangePage,
            scrollRef,
        } = this.props;

        return (
            <Root className={className}>
                <StartScreenDirection
                    extractData={() => tools.getStartScreenData(directions, direction)}
                    handleOpenPopUp={handleOpenPopUp}
                    handleChangePage={handleChangePage}
                    extractCheckboxes={() => tools.getCheckboxes(filters)}
                    direction={direction}
                />
                {/* eslint-disable-next-line max-len */}
                {/* eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/anchor-is-valid */}
                <a name="services" id="services" />
                <DirectionServices>
                    {
                        services.map((service) => (
                            <DropDownList
                                key={service.uuid}
                                service={service}
                                onLookDecisionsButtonClick={this.handleSwitchFilter}
                                scrollToDecitions={this.scrollToDecitions}
                            />
                        ))
                    }
                </DirectionServices>
                {/* eslint-disable-next-line max-len */}
                {/* eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/anchor-is-valid */}
                <a name="decisions" id="decisions" />
                <StyledDecisions
                    decisions={casesState.cases}
                    filters={filters}
                    moreDownloadNum={tools.getMoreDownloadNum(casesState)}
                    onMoreDownloadButtonClick={this.handleGetMoreCases}
                    handleOpenPopUp={handleOpenPopUp}
                    handleSwitchFilter={this.handleSwitchFilter}
                    sliderRef={this.sliderRef}
                    sliderWrapperRef={this.sliderWrapperRef}
                    isChangeFilter={isChangeFilter}
                    isLoadMoreCases={isLoadMoreCases}
                />
                <AnimationContainer
                    withoutMountAndLocationUpdate
                    fade={isChangeFilter || isLoadMoreCases ? 'fadeOut' : 'fadeIn'}
                    callback={isChangeFilter || isLoadMoreCases ? this.getCases : null}
                >
                    <StyledContactsFormBlock
                        extractCheckboxes={() => tools.getCheckboxes(filters)}
                        scrollRef={scrollRef}
                    />
                </AnimationContainer>
                <Footer handleChangePage={handleChangePage} />
            </Root>
        );
    }
}

const StyledContactsFormBlock = styled(ContactsFormBlock)`
    margin-top: 64px;
    padding: 64px 0px 64px 0px;

    background: #F5F5F5;

    ${mediaWidth.m} {
        margin-top: 96px;
        padding: 96px 0px 96px 0px;
    };
`;

const StyledDecisions = styled(Decisions)`
    margin-top: 64px;

    ${mediaWidth.m} {
        margin-top: 96px;
    };
`;

const DirectionServices = styled.div`
    padding: 64px 0px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${color.PRIMARY};

    >div:nth-child(n+2) {
        margin-top: 80px;
    };

    ${mediaWidth.m} {
        padding: 96px 0px;

        >div:nth-child(n+2) {
            margin-top: 112px;
        };
    };

    ${mediaWidth.l} {
        >div:nth-child(n+2) {
            margin-top: 128px;
        };
    };
`;

const Root = styled.div``;

export default Direction;
